import React from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ children, onViewChange }) => {
  return (
    <div className="flex h-screen bg-[#0A0A0A]">
      <Sidebar onViewChange={onViewChange} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-[#0A0A0A] p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;